// drawerActions.ts
import axios from "axios";
import store from "../../_App/Redux/store";
import { TiroireIncidentApi } from "../../_App/Redux/Slices/incident/incidentSlice";

let TiroircachedPort: any = null;
export const TiroirAction = async (dispatch?: any, action?: any) => {
  try {
    const state = store.getState();
    const user = state.auth.user;
    if (action && action === "open button") {
      // create ligne incident
      await dispatch(TiroireIncidentApi({ user }));
    }
    if (TiroircachedPort && TiroircachedPort.writable) {
      await sendCommand(TiroircachedPort);
      return;
    }

    const ports = await (navigator as any).serial.getPorts();
    if (ports.length > 0) {
      TiroircachedPort = ports[0];
      if (!TiroircachedPort.writable) {
        await TiroircachedPort.open({ baudRate: 9600 });
      }
      await sendCommand(TiroircachedPort);
      return;
    }

    TiroircachedPort = await (navigator as any).serial.requestPort();
    await TiroircachedPort.open({ baudRate: 9600 });
    await sendCommand(TiroircachedPort);
    if (action && action === "open button") {
      // create ligne incident
      await dispatch(TiroireIncidentApi({ user }));
    }
  } catch (error: any) {
    console.error("Failed to open drawer:", error);
    return false;
  }
};

async function sendCommand(port: any) {
  const writer = port.writable.getWriter();
  const command = new Uint8Array([0x1b, 0x70, 0x00, 0x19, 0xff]);
  await writer.write(command);
  writer.releaseLock();
}
